<script lang="ts">
  import Caret from "~icons/ph/caret-down";

  let { phone }: { phone: string } = $props();
</script>

<details>
  <summary>How will I receive payment?<Caret /></summary>
  <p>
    You’ll connect your bank account to receive a direct deposit.
  </p>
  <p>
    To accomplish this, we use Tink as our secure payments partner which lets you connect your bank of choice right here
    in your portal for an easy transfer.
  </p>
  <p>
    If you don’t have a bank account OR don’t want to accept payment, please contact us at <a
      class="underline text-blue-500"
      href="tel:{phone}">{phone}</a> to discuss your options.
  </p>
</details>
